import { render, staticRenderFns } from "./FullScreenHeader.vue?vue&type=template&id=10ef7497&scoped=true"
import script from "./FullScreenHeader.vue?vue&type=script&lang=js"
export * from "./FullScreenHeader.vue?vue&type=script&lang=js"
import style0 from "./FullScreenHeader.vue?vue&type=style&index=0&id=10ef7497&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef7497",
  null
  
)

export default component.exports